var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrokenExpiredLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 162,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.001
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.85 60L71 38.381M98.85 60l7.852-21.619M88.85 55.975V33",
    stroke: "#0528A0",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    keyTimes: "0;0.9;1",
    values: "0;0;1;",
    dur: "1.2s",
    fill: "freeze"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M83.54 55.049s-21.713-.11-22.762 0C44.712 56.726 36.632 71.084 37.013 81.21c.355 9.434 7.03 24.15 23.765 25.492 1.002.08 22.762 0 22.762 0M60.4 81.834H89",
    stroke: "#0528A0",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    fill: "freeze",
    attributeType: "XML",
    type: "rotate",
    begin: "1s",
    from: "0 89 110",
    to: "-30 89 110",
    dur: "0.1s"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M94.46 55.049s21.713-.11 22.762 0c16.066 1.677 24.146 16.035 23.765 26.162-.355 9.434-7.029 24.15-23.765 25.492-1.002.08-22.762 0-22.762 0M89 81.834h28.483",
    stroke: "#0528A0",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    fill: "freeze",
    attributeType: "XML",
    type: "rotate",
    begin: "1s",
    from: "0 89 110",
    to: "30 89 110",
    dur: "0.1s"
  }))));
}
export default SvgBrokenExpiredLink;